export const BASE_COIN_NAME = 'Ether';
export const PROVIDER_URL_STORAGE_KEY = 'GRAPHQL_API_ENDPOINT_V3';
export const PROVIDER_VERSION_STORAGE_KEY = 'GRAPHQL_API_ENDPOINT_VERSION';
